// Shared vocabulary for the calling lead-time picker, used by the activity
// form (per-activity override) and the team-category settings (the default).
//
// Encoding mirrors the backend: -1 = off, 0 = on create, N = N days before the
// activity starts. The activity form adds `null` = inherit the category.

// CALLING_LEAD_VALUES are the concrete (non-inherit) options, in display order.
export const CALLING_LEAD_VALUES = [-1, 0, 1, 2, 3, 5, 7, 14] as const;

// leadOptionKey maps a lead value to its i18n key under `callings.lead.*`.
export function leadOptionKey(value: number | null): string {
  if (value === null) return 'callings.lead.inherit';
  if (value === -1) return 'callings.lead.off';
  if (value === 0) return 'callings.lead.onCreate';
  return `callings.lead.d${value}`;
}

// Sentinel used in <Select> components, which can't carry null/negative values
// cleanly as option ids. Map to/from these on the boundary.
export const LEAD_INHERIT = 'inherit';
export const LEAD_OFF = 'off';

export function leadToSelect(value: number | null): string {
  if (value === null) return LEAD_INHERIT;
  if (value === -1) return LEAD_OFF;
  return String(value);
}

// leadFromSelect converts a <Select> value back to the API encoding.
// allowInherit=false (category settings) collapses inherit → off.
export function leadFromSelect(raw: string, allowInherit: boolean): number | null {
  if (raw === LEAD_INHERIT) return allowInherit ? null : -1;
  if (raw === LEAD_OFF) return -1;
  const n = Number(raw);
  return Number.isFinite(n) ? n : -1;
}
